import { useMemo } from 'react'

import { getNewMetricsAvailability } from '../helpers/newMetricsAvailability'
import { useImpressionShareEnabled } from './useImpressionShareEnabled'
import { useNtbMetricsEnabled } from './useNtbMetricsEnabled'

type ImpressionShareScope = {
  /** publisher em escopo; sem ele a família de IS fica só pelo payload */
  publisherId?: string | null
  advertiserId?: string | null
  /** o entitlement decide sozinho (view de campanha), sem olhar o payload */
  fromEntitlement?: boolean
}

type Options = {
  /** false quando a tela não está ancorada em um publisher (NTB some) */
  anchored?: boolean
  impressionShare?: ImpressionShareScope
}

/**
 * Disponibilidade das métricas novas: o payload decide a base; a família de
 * Impression Share obedece ao entitlement do publisher em escopo, e NTB passa
 * pelo gate por conta (allow_ntb_metrics) e, quando a tela exige, pela
 * ancoragem em um publisher. `sources` deve ser memoizado pelo chamador.
 */
export const useNtbAvailability = (
  sources: Array<object | null | undefined>,
  { anchored = true, impressionShare }: Options = {}
): NewMetricsAvailability => {
  const ntbEnabled = useNtbMetricsEnabled()
  const publisherId = impressionShare?.publisherId ?? null
  const fromEntitlement = !!impressionShare?.fromEntitlement
  const impressionShareEnabled = useImpressionShareEnabled({
    publisherId,
    advertiserId: impressionShare?.advertiserId ?? null
  })

  return useMemo(() => {
    let metrics = getNewMetricsAvailability(sources)

    if (fromEntitlement || (publisherId && !impressionShareEnabled)) {
      const enabled = fromEntitlement ? impressionShareEnabled : false

      metrics = {
        ...metrics,
        impressionShare: enabled,
        lostIsRank: enabled,
        lostIsBudget: enabled
      }
    }

    if (ntbEnabled && anchored) return metrics

    return { ...metrics, newToBrandCustomers: false, newToBrandRevenue: false }
  }, [
    sources,
    ntbEnabled,
    anchored,
    publisherId,
    fromEntitlement,
    impressionShareEnabled
  ])
}
